import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__useEventListener_index_js_66e788f5__ from "../useEventListener/index.js";
function measureHeight() {
    var _document_documentElement;
    return (null === (_document_documentElement = document.documentElement) || void 0 === _document_documentElement ? void 0 : _document_documentElement.clientHeight) || window.innerHeight;
}
function use100vh() {
    const [height, setHeight] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(measureHeight);
    const setMeasuredHeight = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        const measuredHeight = measureHeight();
        setHeight(measuredHeight);
    }, []);
    (0, __WEBPACK_EXTERNAL_MODULE__useEventListener_index_js_66e788f5__.useEventListener)('resize', setMeasuredHeight);
    return height ? `${height}px` : '100vh';
}
export { use100vh };
